import moment from "moment";
import Vue from 'vue';
import {
  router
} from '@/router';
import _ from "lodash";
import store from '@/store';
// import { authenticationService } from "@/services/AuthenticationService";

function initialState() {
  return {
    paging: {},
    items: [],
    SimpleStoreObject: {
      username: null,
    }
  };
};
const state = initialState();

const mutations = {
  ON_RESET_SAMPLE_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
};

const actions = {
  onResetSampleStoreState: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit('ON_RESET_SAMPLE_STORE_STATE');
  },
};

const getters = {
  getSampleItems: state => state.items,
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/SampleStore.js